<template>
  <div class="new-goods-container">
    <!-- 显示成功消息 -->
    <div v-if="successMessage" class="success-message">
      {{ successMessage }}
      <i class="el-icon-success"></i>
    </div>

    <!-- 表单内容 -->
    <el-form
      v-else
      :model="form"
      ref="form"
      :rules="rules"
      label-width="120px"
      class="new-goods-form"
    >
      <!-- 基础信息 -->
      <div class="section-title">基础信息</div>
      <el-form-item label="商品名称" prop="goodsName">
        <el-input
          v-model="form.goodsName"
          placeholder="请输入商品名称"
          @input="updateCharacterCount"
          :disabled="!isEditingName"
          @change="validateGoodsName"
        >
          <template slot="suffix">
            <span class="inner-char-count">{{ byteLength }}/60</span>
          </template>
        </el-input>
        <span v-if="nameExistsError" class="error">{{ nameExistsError }}</span>
      </el-form-item>

      <el-form-item label="AI问题" prop="aiQuestion">
        <el-input
          v-model="form.aiQuestion"
          placeholder="请填写消费者感兴趣的问题(示例：红薯适合什么人吃？)"
          @input="updateaiQuestionCount"
          :disabled="!isEditingaiQuestion"
        >
          <template slot="suffix">
            <span class="inner-char-count">{{ aiQuestionbyteLength }}/100</span>
          </template>
        </el-input>
      </el-form-item>

      <!-- 销售信息 -->
      <div class="section-title">销售信息</div>
      <!-- 价格输入框 -->
      <el-form-item label="价格" prop="goodsPrice">
        <div style="display: flex; align-items: center">
          <el-input
            v-model="form.goodsPrice"
            placeholder="精确到小数点后2位"
            @input="updatePriceInput"
            @paste.native="handlePaste"
            style="width: 400px; margin-right: 5px"
          ></el-input>
          <span style="color: #999">元</span>
        </div>
      </el-form-item>

      <!-- 库存输入框 -->
      <el-form-item label="库存" prop="goodsInventory">
        <el-input
          v-model="form.goodsInventory"
          :maxlength="15"
          @input="handleInput"
          placeholder="请输入库存数"
          style="width: 400px"
        >
        </el-input>
        <span style="color: #999; padding-left: 5px">{{ counter }}/15 件</span>
      </el-form-item>

      <!-- 商品图片 -->
      <div class="section-title">商品图片</div>
      <el-form-item label="商品主图" prop="goodsImage">
        <el-upload
          ref="upload"
          class="avatar-uploader"
          action=""
          :show-file-list="false"
          :on-change="handleAvatarChange"
          :auto-upload="false"
          :disabled="fileUploadDisabled"
          :limit="1"
          :on-exceed="handleExceed"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span style="color: #999"
          >只可上传jpg、png，比例为1:1，大小200KB以内</span
        >
        <div>
          <el-button
            v-if="imageUrl"
            type="danger"
            @click="removeImage"
            size="mini"
            icon="el-icon-delete"
            >删除图片</el-button
          >
        </div>
      </el-form-item>

      <!-- 按钮区域 -->
      <div class="button-container">
        <el-button type="primary" @click="submitForm">确认上架</el-button>
        <el-button @click="unlistGoods">确认下架</el-button>
      </div>
    </el-form>
  </div>
</template>
    
  <script>
export default {
  name: "EditGoods",
  data() {
    return {
      form: {
        goodsId: "", // 商品ID
        goodsImage: "",
        goodsName: "",
        aiQuestion: "",
        goodsPrice: "",
        goodsInventory: "",
      },
      originalGoodsName: "", // 记录原始的商品名称
      byteLength: 0, // 商品名称初始字节长度
      aiQuestionbyteLength: 0, //ai问题初始字节长度
      counter: 0, // 库存字符限制
      imageUrl: "", // 图片预览地址
      fileUploadDisabled: false, // 控制是否禁用上传按钮
      nameExistsError: "", // 错误信息
      isEditingName: true, // 控制是否允许编辑商品名称
      isEditingaiQuestion: true, // 控制是否允许编辑AI问题
      file: null, // 选中的文件对象
      rules: {
        goodsImage: [
          { required: true, message: "该项必填，请输入", trigger: "blur" },
        ],
        goodsName: [
          { required: true, message: "该项必填，请输入", trigger: "blur" },
        ],
        aiQuestion: [
          { required: true, message: "该项必填，请输入", trigger: "blur" },
        ],
        goodsPrice: [
          { required: true, message: "该项必填，请输入", trigger: "blur" },
        ],
        goodsInventory: [
          { required: true, message: "该项必填，请输入", trigger: "blur" },
        ],
      },
      successMessage: "", // 成功消息
    };
  },
  computed: {},

  methods: {
    // 添加敏感词检查方法
    checkSensitiveWords(text) {
      const sensitiveWords = [
        // 违法违规类（新增国家安全与社会稳定相关）
        "毒品",
        "枪支",
        "爆炸物",
        "反动",
        "邪教",
        "台独",
        "藏独",
        "分裂",
        "恐怖分子",
        "极端主义",
        "颠覆国家",
        "打倒",
        "危害国家安全",
        "暴力袭击",
        "人肉搜索",
        "非法集会",
        // 广告法绝对化用语（补充常见违规表述）
        "最",
        "国家级",
        "世界级",
        "最高级",
        "最佳",
        "顶级",
        "极品",
        "第一品牌",
        "独家",
        "绝无仅有",
        "永久",
        "祖传",
        "特效",
        "疗效",
        "根治", // 虚假宣传类
        // 低俗脏话类（补充暴力、色情延伸词）
        "傻逼",
        "卧槽",
        "尼玛",
        "色情",
        "淫秽",
        "嫖娼",
        "嫖妓",
        "卖淫",
        "裸聊",
        "强暴",
        "虐待",
        "血腥",
        // 网络违规与规避监管类（备案重点关注）
        "翻墙",
        "VPN破解",
        "非法软件",
        "黑客",
        "盗号",
        "钓鱼网站",
        "赌博",
        "洗钱",
      ];
      return sensitiveWords.some((word) => text.includes(word));
    },

    calculateByteLength(str) {
      let length = 0;
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255) {
          // 如果是中文字符
          length += 2; // 中文字符算作2个字节
        } else {
          length += 1; // 英文字母、数字和符号算作1个字节
        }
      }
      return length;
    },

    //// 商品名称输入框
    updateCharacterCount() {
      this.byteLength = this.calculateByteLength(this.form.goodsName);
    },

    //// AI问题输入框
    updateaiQuestionCount() {
      this.aiQuestionbyteLength = this.calculateByteLength(
        this.form.aiQuestion
      );
    },

    //// 价格输入框
    handlePaste(event) {
      // 阻止默认粘贴行为
      event.preventDefault();
    },
    // 处理输入值的方法，确保最多两位小数且只有一个小数点
    updatePriceInput(value) {
      // 移除所有非数字及非小数点字符
      let cleanedValue = value.replace(/[^0-9.]/g, "");

      // 确保只有一个小数点，移除多余的
      const parts = cleanedValue.split(".");
      if (parts.length > 2) {
        // 如果有多个小数点，则只保留第一个，并把后面的数字合并
        cleanedValue = parts[0] + "." + parts.slice(1).join("");
      }

      // 限制小数点后最多两位数字
      if (parts.length === 2 && parts[1].length > 2) {
        cleanedValue = parts[0] + "." + parts[1].substring(0, 2);
      }

      // 更新输入框显示的值
      this.form.goodsPrice = cleanedValue;
    },

    //// 库存输入框
    handleInput(value) {
      // 清除所有非数字字符
      this.form.goodsInventory = value.replace(/\D/g, "");
      // 更新字符计数器
      this.counter = this.form.goodsInventory.length;
    },
    //// 处理图片选择
    handleAvatarChange(file) {
      this.fileUploadDisabled = false; // 每次开始处理时先重置上传按钮状态
      // 验证文件类型和文件大小
      const isJPGorPNG = ["image/jpeg", "image/png"].includes(file.raw.type);
      const isLt200KB = file.raw.size / 1024 <= 200;

      if (!isJPGorPNG) {
        this.$message.error("只能上传jpg或png类型的文件");
        this.resetUpload(); // 添加：重置上传状态
        return;
      }

      if (!isLt200KB) {
        this.$message.error("图片质量较大，请上传小质量图片");
        this.resetUpload(); // 添加：重置上传状态
        return;
      }
      // 使用 FileReader 读取文件并生成预览
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          // 图片比例检查
          if (img.width !== img.height) {
            this.$message.error("请上传比例为1:1的图片");
            this.resetUpload(); // 添加：重置上传状态
            return;
          }
          // 更新图片预览
          this.imageUrl = e.target.result;
          // 如果验证通过，禁用上传按钮
          this.fileUploadDisabled = true;
        };
      };
      reader.readAsDataURL(file.raw); // 读取文件为 Data URL
      this.form.goodsImage = file.raw; // 将文件对象赋值给 form
    },

    resetUpload() {
      // 清除上传组件中的文件列表
      this.$refs.upload.clearFiles();
      // 重置图片预览
      this.imageUrl = "";
      this.fileUploadDisabled = false; // 允许用户重新上传
    },

    handleExceed(files, fileList) {
      this.$message.warning(`最多上传一份文件`);
    },

    removeImage() {
      // 清除图片预览
      this.imageUrl = "";
      this.form.goodsImage = "";
      this.resetUpload(); // 添加：重置上传状态
    },
    // 添加 beforeunload 事件处理函数：
    beforeUnloadHandler(event) {
      event.preventDefault(); // 确保显示确认对话框
      event.returnValue = "离开此网站？\n系统可能不会保存您所做的更改。";
    },

    // 获取商品详情并填充表单
    async fetchGoodsDetail(goodsId) {
      try {
        const response = await this.$http.get("/api/goodsbyid", {
          params: { id: goodsId }, // 通过params选项传递query参数
        });
        const goodsData = response.data;
        this.form.goodsId = goodsData._id;
        this.form.goodsName = goodsData.goodsName;
        this.form.aiQuestion = goodsData.aiQuestion;
        this.form.goodsPrice = goodsData.goodsPrice;
        this.form.goodsInventory = goodsData.goodsInventory;

        // 处理goodsImage，仅保留文件名
        const imageUrl = new URL(goodsData.goodsImage);
        this.form.goodsImage = imageUrl.pathname; // 相对路径  //.split("/").pop(); // 获取最后一部分作为文件名
        this.imageUrl = goodsData.goodsImage; // 完整URL用于显示

        // 保存原始的商品名称用于比较
        this.originalGoodsName = this.form.goodsName;

        // 触发视图更新以显示已填充的数据
        this.$forceUpdate();
        this.fileUploadDisabled = true; // 禁止上传图片
      } catch (error) {
        this.$message.error("获取商品详情失败");
        console.error(error);
      }
    },

    // 在输入框失去焦点后调用 validateGoodsName 方法进行验证
    validateGoodsName() {
      if (this.form.goodsName !== this.originalGoodsName) {
        this.checkGoodsName(this.form.goodsName).then((isAvailable) => {
          if (!isAvailable) {
            this.nameExistsError = "该商品名称已存在，请换一个名称";
          } else {
            this.nameExistsError = "";
          }
        });
      } else {
        this.nameExistsError = "";
      }
    },

    // 检查商品名称是否唯一
    async checkGoodsName(goodsName) {
      try {
        const response = await this.$http.post("/api/goods/check-goods-name", {
          goodsName,
        });
        // 如果后端返回的消息是"商品名称可用"，则返回true，否则返回false
        return response.data.message === "商品名称可用";
      } catch (error) {
        this.$message.error("未授权或发生错误");
        return false;
      }
    },

    // 确认上架
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 新增：敏感词检查
          const hasSensitive =
            this.checkSensitiveWords(this.form.goodsName) ||
            this.checkSensitiveWords(this.form.aiQuestion);
          if (hasSensitive) {
            this.$message.error("内容包含敏感词，请修改后提交");
            return;
          }

          if (this.form.goodsName !== this.originalGoodsName) {
            const isAvailable = await this.checkGoodsName(this.form.goodsName);
            if (!isAvailable) {
              this.$message.error("该商品名称已存在，请换一个名称");
              return;
            }
          }

          // 如果商品名称可用，如果有新上传的图片，更新图片路径
          if (this.form.goodsImage instanceof File) {
            const formData = new FormData();
            formData.append("image", this.form.goodsImage);

            try {
              const uploadResponse = await this.$http.post(
                "/api/goods/upload-image",
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              );
              // 更新为新的图片路径
              this.form.goodsImage = uploadResponse.data.imageUrl;
            } catch (error) {
              this.$message.error("图片上传失败");
              console.error(error);
              return;
            }
          }

          try {
            await this.$http.put(
              "/api/goods/list-goods-update",
              { ...this.form }, // 当前对象状态快照
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );
            sessionStorage.setItem("successMessage", "上架成功");
            // 提交成功后移除 beforeunload 事件监听器
            window.removeEventListener(
              "beforeunload",
              this.beforeUnloadHandler
            );
            window.location.reload(); // 刷新页面
          } catch (error) {
            this.$message.error("商品上架失败");
            console.error(error);
          }
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },

    // 确认下架
    async unlistGoods() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 新增：敏感词检查
          const hasSensitive =
            this.checkSensitiveWords(this.form.goodsName) ||
            this.checkSensitiveWords(this.form.aiQuestion);
          if (hasSensitive) {
            this.$message.error("内容包含敏感词，请修改后提交");
            return;
          }

          if (this.form.goodsName !== this.originalGoodsName) {
            const isAvailable = await this.checkGoodsName(this.form.goodsName);
            if (!isAvailable) {
              this.$message.error("该商品名称已存在，请换一个名称");
              return;
            }
          }

          // 如果商品名称可用，如果有新上传的图片，更新图片路径
          if (this.form.goodsImage instanceof File) {
            const formData = new FormData();
            formData.append("image", this.form.goodsImage);

            try {
              const uploadResponse = await this.$http.post(
                "/api/goods/upload-image",
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              );
              // 更新表单中的图片URL
              this.form.goodsImage = uploadResponse.data.imageUrl;
            } catch (error) {
              this.$message.error("图片上传失败");
              console.error(error);
              return;
            }
          }

          try {
            await this.$http.put(
              "/api/goods/unlist-goods-update",
              { ...this.form }, // 当前对象状态快照
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );
            sessionStorage.setItem("successMessage", "下架成功");
            // 提交成功后移除 beforeunload 事件监听器
            window.removeEventListener(
              "beforeunload",
              this.beforeUnloadHandler
            );
            window.location.reload(); // 刷新页面
          } catch (error) {
            this.$message.error("商品下架失败");
            console.error(error);
          }
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },

    // 当用户开始编辑时重新添加 beforeunload 监听器
    handleFormChange() {
      window.addEventListener("beforeunload", this.beforeUnloadHandler);
    },
  },

  mounted() {
    // 页面加载时调用fetchGoodsDetail获取当前商品的详细信息
    const goodsId = this.$route.query.id; // 使用query参数获取商品ID
    if (goodsId) {
      this.fetchGoodsDetail(goodsId);
    } else {
      this.$message.error("未找到商品ID");
    }

    // 页面加载时检查是否有成功消息
    const successMessage = sessionStorage.getItem("successMessage");
    if (successMessage) {
      this.successMessage = successMessage;
      sessionStorage.removeItem("successMessage"); // 清除存储的消息
    }

    // 监听表单的变化以重新添加 beforeunload 事件监听器
    this.$watch(() => JSON.stringify(this.form), this.handleFormChange, {
      immediate: true,
    });
  },

  beforeDestroy() {
    // 移除 beforeunload 事件监听器
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  },

  watch: {
    // 商品名称限制60字符
    "form.goodsName": function (newVal) {
      if (this.byteLength > 60) {
        this.form.goodsName = newVal.slice(0, -1); // 移除最后一个字符以确保不超过限制
        this.byteLength = this.calculateByteLength(this.form.goodsName);
      }
    },

    // ai问题限制100字符
    "form.aiQuestion": function (newVal) {
      if (this.aiQuestionbyteLength > 100) {
        this.form.aiQuestion = newVal.slice(0, -1); // 移除最后一个字符以确保不超过限制
        this.aiQuestionbyteLength = this.calculateByteLength(
          this.form.aiQuestion
        );
      }
    },
  },
};
</script>
    
  <style scoped>
.new-goods-container {
  padding: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.inner-char-count {
  color: #999;
  position: absolute;
  right: -45px; /* 调整与输入框右边界的距离 */
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* 确保点击计数器时不会触发输入框的聚焦 */
}

/* 确保单位与输入框在同一行 */
.el-input-group__append {
  display: inline-block;
  padding: 0 10px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  line-height: 38px; /* 根据实际高度调整 */
}

.inner-char-count-stock {
  color: #999;
  margin-left: 5px; /* 调整与输入框边界的距离 */
}

.unit {
  margin-left: 10px;
  color: #999;
}

.new-goods-form {
  max-width: 1200px;
  margin: 0 auto;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px solid rgb(199, 199, 199);
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  position: relative;
}

.delete-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}

.button-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 10px; /* 按钮之间的间距 */
}

.error {
  color: red; /* 设置文本颜色为红色 */
}
</style>